<template>
  <div class="container">
    <div class="conditions_box">
      <img src="@/assets/archedShape2.png" class="img-fluid gonbad"/>

      <div class="row">

        <div class="col-12 col-md-8 mx-auto">
          <div class="content-wrapper">
            <h1>ثبت نام اولیه سامانه پلیس امنیت</h1>
            <div class="card content-box">
              <div class="card-body">
                <div class="bg-success text-white">
                  <div class="m-3">
                    <div class="image justify-content-center align-items-center"><img src="@/assets/policeLogo.png"  alt="img" class="img-fluid col-10"/></div>
                    <span> فرهیخته گرامی جناب آقای پوریا محمدی </span><br>
                    <span> سلام علیکم </span><br>
                    <span> اطلاعات شما به صورت کامل ثبت و برای تایید نهایی و معرفی به پلیس امنیت </span><br>
                    <span> عمومی نیروی انتظامی ارسال خواهد شد. </span><br><br><br>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.mainBox{
position: fixed;
width: 480px;
height: 60px;
top: 15%;
left: 50%;
margin-top: -100px; /* Negative half of height. */
margin-left: -250px; /* Negative half of width. */

}
.gonbad{
  z-index: -1;
  margin-bottom: -24px;
}
.content-box{
  height: 100%;
  direction: rtl;
  text-align: justify;
  margin-top: 45px;
}
</style>
<script>
/*import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  }
}*/
</script>
